import { Component, OnInit } from "@angular/core";

@Component({
  selector: "[sk-education]",
  templateUrl: "./education.component.html",
  styleUrls: ["./education.component.css"],
})
export class EducationComponent implements OnInit {
  isMasterDegreeView: boolean = true;
  constructor() {}

  ngOnInit() {}

  handleViewClick(currentDegree: string) {
    this.isMasterDegreeView = currentDegree == "masters" ? true : false;
  }
}
